import { useTranslation } from 'react-i18next';
import { Container, StyledTable, TableBody, TableRow, TableCell, EmptyState } from './index.styles';
import { formatTableCellValue, resolveMetricLabel, METRIC_LABEL_KEYS } from '../../../../helpers';
import ProfileIcons from '../../../ProfileIcons';

export const RankedTableRenderer = ({ data, selectedProfiles, supportedPlatforms }: DynamicModuleBuilderProps) => {
  const { t } = useTranslation('reports');

  if (!data || data.chartType !== 'RankedTable') {
    return <EmptyState>{t('new_reports_no_posts_to_display')}</EmptyState>;
  }

  const { columns, options } = data;
  const rows = data.data as TableCellValue[][];

  if (!rows || rows.length === 0) {
    return <EmptyState>{t('new_reports_no_posts_to_display')}</EmptyState>;
  }

  const highlightFirstRow = options?.highlightFirstRow ?? false;

  return (
    <>
      <Container>
        <StyledTable>
          <TableBody role="table">
            {rows.map((row, idx) => {
              const highlighted = highlightFirstRow && idx === 0;
              const isTopThree = idx < 3;

              return (
                <TableRow
                  key={idx}
                  role="row"
                  $highlighted={highlighted}
                  $isTopThree={isTopThree}
                >
                  {row.map((cell, colIdx) => {
                    const colType = columns?.[colIdx]?.type;
                    const isNumeric = colType === 'percentage' || colType === 'number';

                    return (
                      <TableCell
                        key={colIdx}
                        role="cell"
                        $align={isNumeric ? 'right' : 'left'}
                        $colType={colType}
                        $highlighted={highlighted}
                        $isTopThree={isTopThree}
                      >
                        {typeof cell === 'string' && cell in METRIC_LABEL_KEYS
                          ? resolveMetricLabel(cell, t)
                          : formatTableCellValue(cell, colType as MetricValueType, t)}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </StyledTable>
      </Container>
      <ProfileIcons
        selectedProfiles={selectedProfiles}
        supportedPlatforms={supportedPlatforms}
      />
    </>
  );
};
